import { render, staticRenderFns } from "./uv-configuration.configuration.vue?vue&type=template&id=1dccf4b0&"
import script from "./uv-configuration.configuration.vue?vue&type=script&lang=ts&"
export * from "./uv-configuration.configuration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports